















import Vue from 'vue';
import Component from 'vue-class-component';
import BaseComponent from '@/components/base-component.vue';
import * as $Logout from '@/subjects/logout';

@Component
export default class Logout extends BaseComponent {
  public logout() {
    $Logout.logout();
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }
}
